/*
 * @Description:
 * @version:
 * @Author: xiexing
 * @Date: 2021-01-20 14:11:47
 * @LastEditors: wangsen03 wangsen03@zhuanzhuan.com
 * @LastEditTime: 2024-11-14 11:28:10
 */
/**
 * axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from '@zz-yp/hunter-js-utils/es/fetch'
import { reLogin } from '@lib/login'
import { sentryCapture } from '@zz-common/sentry'
import DomainMaps from '@maps/domainMaps'
import { Report } from '@zz-yp/hunter-sentry-report'
import { setCookie } from '@/lib/helper'
import Crypto from 'crypto-js'
import { day } from '@zz-yp/hunter-js-utils'

// 约定特殊key，防爬虫
const antiCrawling = () => {
  const md5 = Crypto.MD5(`CHX${day().format('YYYY-MM-DD')}CHX`).toString()
  setCookie('bmhhnajke', md5)
}
antiCrawling()
axios.defaults.allData = true
axios.defaults.hasConfig = true // reject是否包含config信息
axios.defaults.baseURL = DomainMaps.appDomain // 设置默认请求域名

axios.interceptors.request.use((config) => {
  // 统一校对协议 改为https://
  const httpReg = /(.*)(?=\/\/)/i
  config.url = config.url.replace(httpReg, 'https:')

  return config
})

axios.interceptors.response.use(
  (response) => {
    return Promise.resolve(response)
  },
  async (err) => {
    let msg = '服务异常，请稍后再试'
    let code = 0
    let fullRes = false
    let fullData = null

    const whiteCode = [-1000, -2, -8]
    const whiteMsg = [
      '请前往个人中心-收款方式，绑定银行卡作为收款账户，才可申请售后',
      '数据请求中，请稍后',
      '距竞拍结束10分钟内，禁止出价或改价~',
      '获取场次信息失败',
      '请登录'
    ]
    await Report(err, whiteCode)
      .then((res) => {
        msg = res.msg
        code = res.respCode || 0
        fullRes = res.fullRes
        fullData = res.respData
        if (!res.canReport || whiteMsg.includes(msg)) return
        const reportObj = res.reportObj || {}
        sentryCapture(res.reportMsg, 'warning', { ...reportObj, tags: { sentryHealth: 'ignore' } })
      })
      .catch((e) => {
        console.error('axios Report catch', e)
      })
    const loginCodeArr = [-2, -8] // 符合调用登陆的code
    if (loginCodeArr.indexOf(code) > -1 && !err.config?.ignoreLogin) {
      reLogin((data) => {
        console.log('axios reLogin data: ', data)
        // alert(data.msg)
      })
    }

    // 支持hasConfig配置，返回完整的错误信息
    if (axios.defaults.hasConfig && err.config && err.config.hasConfig) {
      const errorObj = new Error(fullRes ? fullData : msg)
      errorObj.response = err.response
      errorObj.config = err.config
      errorObj.status = err.response?.status
      errorObj.message = fullRes ? fullData : msg
      return Promise.reject(errorObj)
    }

    return Promise.reject(fullRes ? fullData : msg)
  }
)
// Vue.prototype.$http = axios
export default axios
export const fetch = {
  install(vue) {
    vue.prototype.$http = axios
  }
}
